// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZdK9BvmWKwwfNDNHg7i4o1kvS-g6uFyc",
  authDomain: "simple-firebase-authenti-264c7.firebaseapp.com",
  projectId: "simple-firebase-authenti-264c7",
  storageBucket: "simple-firebase-authenti-264c7.appspot.com",
  messagingSenderId: "501749712088",
  appId: "1:501749712088:web:575267b20f0e40c37bc3ad"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
